import Vue from 'vue';
import Bugsnag from 'bugsnag-js';
import BugsnagVue from 'bugsnag-vue';

let BugsnagClient;

if (_bugSnag.key) {
    BugsnagClient = Bugsnag(_bugSnag.key);
    BugsnagClient.use(BugsnagVue(Vue));

    BugsnagClient.releaseStage = this.stage;

    if (this.user) {
        BugsnagClient.user = this.user;
    }
} else {
    BugsnagClient = {
        notify: () => {
            console.error('Bugsnag is not active, api key is missing.');
        },
    };
}

export default BugsnagClient;
